import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {HydraService} from '../../core/services/hydra.service';
import {HydraCollection} from '../../class/generic/hydra-collection';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';

import { MatOption } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';

export interface filterConfiguration {
    api: string; // Si données venant d'une API
    data?: any[]; // Si date données manuellement
    displayProperty: string; // Quel propriété affiché dans le select
    label: string; // Titre du select obligatoirement une clé de traduction
    freeze?: boolean; // Select désactivé
    propertyTranslatable?: boolean; // les données peuvent être traduite
    multipleSelect?: boolean; //activation de la selection multiple
    cacheKey?: string; // Les valeurs séléctionnées sont automatiquement mise en cache et initialisée.
}

export const filterLienDeclare: filterConfiguration = {
    label: 'general.liensInterets',
    freeze: false,
    api: null,
    displayProperty: 'label',
    propertyTranslatable: false,
    multipleSelect: true,
    data: [
        {label: 'L', value: 'L'},
        {label: 'LI', value: 'LI'},
        {label: 'LD', value: 'LD'},
    ],
};

@Component({
    selector: 'app-filter-by-api',
    templateUrl: './filter-by-api.component.html',
    styleUrls: ['./filter-by-api.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, MatOption, TranslateModule]
})
export class FilterByAPIComponent implements OnInit {
    private hydraService = inject(HydraService);



    private _api: string = null;
    public displayProperty: string = null;
    public label = '';
    public disabled = false;
    public propertyTranslatable = false;
    public multipleSelect = false;
    public cacheKey = null;

    @Output() changeSelection = new EventEmitter();
    @Output() onInit = new EventEmitter();

    @Input() matSelectId: string =  'filter-' + Math.random().toString(36);

    @Input() theme = 'fill';
    @Input() color = 'primary';
    @Input() floatLabel = 'auto';

    @Input() set config(value: filterConfiguration) {
        this.propertyTranslatable = (value['propertyTranslatable'] == true);
        this.multipleSelect = (value['multipleSelect'] == true);
        this.cacheKey = (value['cacheKey']) ? value.cacheKey : null;

        if (!value) {
            return;
        }

        // On fige le filtre.
        // @todo : a quoi ça sert ?
        if (value.freeze) {
            this.label = value.label;
            this.selectedValue = null;
            this._api = null;
            this.displayProperty = null;
            this.items = [];
        } else {
            // Plus de freeze on charge les données
            this.disabled = value.freeze;
            // Update via une api
            if (value.api != null && this._api != value.api && value.api.length) {
                this._api = value.api;
                this.loadData();
            } else {
                // Update via des données fournies
                if (value.data != undefined && value.data.length) {
                    this.items = value.data;
                }
                this.initCacheData('value');
            }
            this.displayProperty = value.displayProperty;
            this.label = value.label;
        }

        this.disabled = value.freeze;
    }

    public items: { id; '@id' }[] = [];
    public selectedValue: { id; '@id' } | [] = null;


    public initCacheData(compareProperety = 'id') {
        if (this.cacheKey && this.cacheKey.length) {
            const data = JSON.parse(window.localStorage.getItem(this.cacheKey));
            if (data && typeof data === 'object' && this.multipleSelect == false) {
                this.selectedValue = this.items.find(item => item[compareProperety] == data[compareProperety]);
            } else if (data && this.multipleSelect && Array.isArray(data)) {
                const itemResults = [];
                data.map(item => {
                    itemResults.push(item[compareProperety]);
                });
                this.selectedValue = this.items.filter(item => itemResults.includes(item[compareProperety])) as [];
            }
            this.onInit.emit(this.selectedValue);
        }
    }

    private loadData() {
        this.hydraService.getList(this._api).subscribe((res: HydraCollection) => {
            this.items = res.getMember<{ id; '@id' }[]>();
            this.initCacheData();
        });
    }

    public updateSelection() {
        if (this.cacheKey && this.cacheKey.length) {
            window.localStorage.setItem(this.cacheKey, JSON.stringify(this.selectedValue));
        }
        this.changeSelection.emit(this.selectedValue);
    }

    ngOnInit() {
    }

}
